import classnames from 'classnames';
import { FieldDatePicker } from 'components/common-form/builder/form/node/field/DateField';
import { useFieldValidationError } from 'components/common-form/hooks/useFieldValidationError';
import { usePatchedFieldHighlight } from 'components/common-form/hooks/usePatchedFieldHighlight';
import { FC } from 'react';
import styled from 'styled-components';

const InitialValuationDate: FC<{ className?: string }> = ({ className }) => {
  const validationError = useFieldValidationError('InitialValuationDate', 'quote.errorMessages.');
  const patchedFieldClassName = usePatchedFieldHighlight('InitialValuationDate');
  return (
    <div className={classnames(className, patchedFieldClassName)}>
      <FieldDatePicker id="InitialValuationDate" size="md" hasError={validationError !== undefined} />
    </div>
  );
};
export const StyledInitialValuationDate = styled(InitialValuationDate)`
  width: 100%;
`;
